/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { Apqsv1Checks } from '../models/Apqsv1Checks';
import { Apqsv1HealthCondition } from '../models/Apqsv1HealthCondition';
import { HttpFile } from '../http/http';

export class Apqsv1HealthCheck {
    'serviceName'?: string;
    'healthCondition'?: Apqsv1HealthCondition;
    'commitHash'?: string;
    'serviceVersion'?: string;
    'checks'?: Apqsv1Checks;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "serviceName",
            "baseName": "serviceName",
            "type": "string",
            "format": ""
        },
        {
            "name": "healthCondition",
            "baseName": "healthCondition",
            "type": "Apqsv1HealthCondition",
            "format": ""
        },
        {
            "name": "commitHash",
            "baseName": "commitHash",
            "type": "string",
            "format": ""
        },
        {
            "name": "serviceVersion",
            "baseName": "serviceVersion",
            "type": "string",
            "format": ""
        },
        {
            "name": "checks",
            "baseName": "checks",
            "type": "Apqsv1Checks",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return Apqsv1HealthCheck.attributeTypeMap;
    }

    public constructor() {
    }
}

